<template>
  <div class="login-page">
    <h1 class="title">巡檢管理系統</h1>
    <div class="login-card">
      <el-card class="box-card">
        <!-- <div slot="header" class="clearfix"></div> -->
        <div class="mr-t20">
          <el-form ref="loginForm" :model="form" :rules="rule">
            <el-form-item prop="username">
              <el-input v-model="form.username" placeholder="請輸入用戶名">
                <i slot="prefix" class="el-input__icon el-icon-user-solid"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="form.password" type="password" placeholder="請輸入密碼">
                <i slot="prefix" class="el-input__icon el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <!-- <el-form-item prop="verify">
							<div class="flex flex-col-center flex-row-between">
								<el-input v-model="form.verify" style="width: 220px;" type="password" placeholder="請輸入验证码">
									<i slot="prefix" class="el-input__icon el-icon-lock"></i>
								</el-input>
								<div><img @click="refreshCaptcha" class="captcha" :src="captcha" alt=""></div>
							</div>
						</el-form-item> -->
            <div class="mr-t20 flex flex-row-center">
              <el-button type="primary" style="width: 100%;" @click="onSubmit">登錄</el-button>
            </div>
          </el-form>
        </div>

      </el-card>
    </div>

    <div style="margin-top: 50px;">
      <el-link type="warning" @click="download">app下載</el-link>
    </div>


  </div>
</template>

<script>
  export default {
    data() {
      return {
        form: {
          username: "",
          password: "",
          // verify:""
        },
        captcha: this.$api.BaseUrl + this.$api.admin.captcha,
        rule: {
          username: [{
            required: true,
            message: "用戶名不能爲空",
            trigger: "blur"
          }],
          password: [{
            required: true,
            message: "登錄密碼不能爲空",
            trigger: "blur"
          }],
          // verify: [{
          // 	required: true,
          // 	message: "验证码不能为空",
          // 	trigger: "blur"
          // }],
        }
      }
    },
    created() {

    },
    methods: {
      download() {
        this.$request({
          url: this.$api.version.download,
        }).then((res) => {
          if (res.data.code == 1) {
            location.href = this.$api.imagePath + '/' + res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
      },
      onSubmit() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.$request({
              url: this.$api.admin.login,
              method: "post",
              data: this.form,
            }).then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.msg);
                sessionStorage.setItem("userinfo", JSON.stringify(res.data.data.userinfo));
                sessionStorage.setItem("rules", JSON.stringify(res.data.data.rules));
                sessionStorage.setItem("nodes", JSON.stringify(res.data.data.nodes));
                sessionStorage.setItem('token', res.data.data.token);
                sessionStorage.setItem('name', res.data.data.userinfo.name);
                sessionStorage.setItem('username', res.data.data.userinfo.username);
                sessionStorage.setItem('type', res.data.data.userinfo.type);
                sessionStorage.setItem('role_id', res.data.data.role.id);

                if(res.data.data.userinfo.type==1){
                   sessionStorage.setItem('ename', '設備名稱');
                   sessionStorage.setItem('elocation', '設備位置');
                }else{
                   sessionStorage.setItem('ename', '尋點名稱');
                   sessionStorage.setItem('elocation', '尋點位置');
                }

                setTimeout(() => {
                  this.$router.push({
                    path: "/Main"
                  })
                }, 1000)
              } else {
                this.$message.error(res.data.msg);
              }
            })

          } else {
            return false;
          }
        })
      },
      refreshCaptcha() {

      }
    }
  }
</script>

<style scoped>
  .login-page {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background: url("../assets/images/login_bg.jpg") top center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
  }

  .title {
    color: white;
  }

  .login-card {
    margin-top: 50px;
    width: 400px;
  }

  .box-card {
    /* padding: 20px; */
  }

  .captcha {
    width: 120px;
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue